import { Sparkles } from "lucide-react";
import type { Suggestion } from "../lib/suggestions";

interface Props {
  suggestions: Suggestion[];
  /** Pre-fill the agent input with the suggestion's text. NOT
   *  auto-send — the operator still presses Send so they can edit. */
  onPick: (prefill: string) => void;
}

/**
 * Strip of contextual follow-ups under the LastReplyCard. Visible
 * only when `computeSuggestions` produced at least one — we'd rather
 * show nothing than show generic filler that trains operators to
 * ignore the strip.
 */
export function SuggestionPills({ suggestions, onPick }: Props) {
  if (suggestions.length === 0) return null;
  return (
    <div
      role="group"
      className="max-w-6xl mx-auto mt-1 px-4 flex items-center gap-2 flex-wrap"
      aria-label="Actions suggérées"
    >
      <Sparkles
        className="h-3 w-3 text-chip-orange shrink-0"
        aria-hidden
      />
      <span className="text-xs text-muted dark:text-muted-dark shrink-0">
        Actions suggérées&nbsp;:
      </span>
      <span className="sr-only">
        Un clic préremplit la réponse sans l'envoyer.
      </span>
      {suggestions.map((s, i) => (
        <button
          key={`${s.label}-${i}`}
          type="button"
          onClick={() => onPick(s.prefill)}
          className="px-3 py-1 text-xs rounded-full bg-white dark:bg-surface-dark ring-1 ring-black/10 dark:ring-white/10 text-ink dark:text-ink-dark hover:ring-ink/40 dark:hover:ring-white/40 hover:bg-canvas dark:hover:bg-canvas-dark transition"
          title={s.prefill}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
